import * as React from "react";
import { connect } from "react-redux";
import { RootState } from "~/state";
import { Category, StatusMessage } from "~/state/ui/StatusMessage";
import { getStatusMessages } from "~/state/action";
import { statusDismiss, statusAdd } from "~/state/ui/action";
import { StatusBarMessage } from "./StatusBarMessage";
import styled from "styled-components";

export interface Props
{
    className?: string;
    style?: React.CSSProperties;
    category?: Category;
}

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootState, ownProps: Props) => ({
    messages: getStatusMessages(state, ownProps.category)
});

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    dismiss: (id: string) => dispatch(statusDismiss(id)),
    addStatus: (status: StatusMessage) => dispatch(statusAdd(status))
});

const Container = styled.div`
    
`;

class StatusBar extends React.Component<Props & StateProps>
{
    private onDismissMessage = (id: string) =>
    {
        this.props.dismiss(id);
    }

    render()
    {
        const { messages, className, style } = this.props;
        return (
            <Container className={className} style={style}>
                {messages.map(message => (
                    <StatusBarMessage key={message.id} message={message} onDismiss={this.onDismissMessage} />
                ))}
            </Container>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StatusBar);



// WEBPACK FOOTER //
// ./src/components/util/StatusBar.tsx